import type {SketchLineObject} from '../../../../../mesh/sketch';
import {SketchRelationKind} from '../../relation-compatibility/SketchRelationKinds';
import {SketchLineMultiRelationConstraint} from './SketchLineMultiRelationConstraint';

let count = 0;

/**
 * 判断对象是否为平行关系。
 * @param value 待判断对象。
 * @returns 是否为平行关系。
 */
export function isLineParallelConstraint(value: object): value is LineParallelConstraint {
    return Reflect.get(value, 'isLineParallelConstraint') === true;
}

/**
 * 直线平行关系定义。
 *
 * 几何计算由统一参数公式完成；本类不保存锚线或传播顺序。
 */
export class LineParallelConstraint extends SketchLineMultiRelationConstraint<SketchLineObject> {
    /** 运行时类型标记。 */
    public readonly isLineParallelConstraint = true;
    /** 关系类型。 */
    public relationType = SketchRelationKind.Parallel;

    public constructor() {
        super();
        this.name = `${this.baseDisplayName}${count}`;
        count += 1;
    }

    /** 基础显示名。 */
    public get baseDisplayName(): string {
        return '平行';
    }
}
